import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { MissingPageComponent } from '../components/missing-page/missing-page.component';
import { RoyaltiesComponent } from '../components/royalties-raport/royalties.component';
import { CompanyBillingComponent } from '../dashboards/company-billing/company-billing.component';
import { CompanyMasterdashboardComponent } from '../dashboards/company-masterdashboard/company-masterdashboard.component';
import { DevEChartsChomponent } from '../dashboards/dev-echarts/dev-echarts.component';
import { MopaAbtestsComponent } from '../dashboards/mopa-abtests/mopa-abtests.component';
import { MopaAdsComponent } from '../dashboards/mopa-ads/mopa-ads.component';
import { MopaCampaignsChartsComponent } from '../dashboards/mopa-campaigns-charts/mopa-campaigns-charts.component';
import { MopaCampaignsComponent } from '../dashboards/mopa-campaigns/mopa-campaigns.component';
import { MopaCustomFunnelsComponent } from '../dashboards/mopa-custom-funnels/mopa-custom-funnels.component';
import { MopaDecoFlowComponent } from '../dashboards/mopa-deco-flow/mopa-deco-flow.component';
import { MopaDevicesComponent } from '../dashboards/mopa-devices/mopa-devices.component';
import { MopaEngagementComponent } from '../dashboards/mopa-engagement/mopa-engagement.component';
import { MopaFunnelsComponent } from '../dashboards/mopa-funnels/mopa-funnels.component';
import { MopaMetaEngagementComponent } from '../dashboards/mopa-meta-engagement/mopa-meta-engagement.component';
import { MopaMetaSummaryComponent } from '../dashboards/mopa-meta-summary/mopa-meta-summary.component';
import { MopaRealtimeCloudSaveStatsComponent } from '../dashboards/mopa-realtime-cloudsave-stats/mopa-realtime-cloudsave-stats.component';
import { MopaRealtimeStatsComponent } from '../dashboards/mopa-realtime-stats/mopa-realtime-stats.component';
import { MopaResourceFlowComponent } from '../dashboards/mopa-resource-flow/mopa-resource-flow.component';
import { MopaResourcesDetailedComponent } from '../dashboards/mopa-resources-detailed/mopa-resources-detailed.component';
import { MopaResourcesComponent } from '../dashboards/mopa-resources/mopa-resources.component';
import { MopaRetentionComponent } from '../dashboards/mopa-retention/mopa-retention.component';
import { MopaSalesComponent } from '../dashboards/mopa-sales/mopa-sales.component';
import { MopaSkadNetworkComponent } from '../dashboards/mopa-skadnetwork/mopa-skadnetwork.component';
import { MopaUsersComponent } from '../dashboards/mopa-users/mopa-users.component';
import { JobsSummaryComponent } from '../pages/jobs/jobs-summary/jobs-summary.component';
import { OrchestratorComponent } from '../pages/jobs/orchestrator/orchestrator.component';
import { OrchestratorsComponent } from '../pages/jobs/orchestrators/orchestrators.component';
import { LoginComponent } from '../pages/login/login.component';
import { UnauthorizedComponent } from '../pages/unauthorized/unauthorized.component';
import { AuthService, GuardData } from '../services/auth.service';
import { NavbarData } from '../services/navbar/navbar.service';

/**
 * Routes are sorted the same way you want them to appear in the navbar
 */
export const dashboardsRoutes: DashboardRoute[] = [
    {
        path: 'company',
        name: 'Company',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewCompany } as GuardData,
        children: [
            {
                path: 'master',
                component: CompanyMasterdashboardComponent,
                name: 'Company masterdash',
            },
        ],
    },
    {
        path: 'mopa',
        name: 'Unsolved',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewMOPA } as GuardData,
        children: [
            {
                path: 'sales',
                component: MopaSalesComponent,
                name: 'Sales',
            },
            {
                path: 'users',
                component: MopaUsersComponent,
                name: 'Users',
            },
            {
                path: 'retention',
                component: MopaRetentionComponent,
                name: 'Retention',
            },
            {
                path: 'engagement',
                component: MopaEngagementComponent,
                name: 'Engagement',
            },
            {
                path: 'campaigns',
                component: MopaCampaignsComponent,
                name: 'Campaigns',
                data: { navbarGroup: 'Campaigns' },
            },
            {
                path: 'campaigns-charts',
                component: MopaCampaignsChartsComponent,
                name: 'Campaigns charts',
                data: { navbarGroup: 'Campaigns' },
            },
            {
                path: 'ads',
                component: MopaAdsComponent,
                name: 'Ads',
            },
            {
                path: 'devices',
                component: MopaDevicesComponent,
                name: 'Devices',
                data: { navbarGroup: 'Tech' },
            },
            {
                path: 'abtests',
                component: MopaAbtestsComponent,
                name: 'A/B Tests',
            },
            {
                path: 'funnels',
                component: MopaFunnelsComponent,
                name: 'Funnels',
                data: { navbarGroup: 'Funnels', disabled: true },
            },
            {
                path: 'customfunnels',
                component: MopaCustomFunnelsComponent,
                name: 'Custom Funnels',
                data: { navbarGroup: 'Funnels' },
            },
            {
                path: 'meta-summary',
                component: MopaMetaSummaryComponent,
                name: 'Meta Summary',
                data: { navbarGroup: 'Meta' },
            },
            {
                path: 'meta-engagement',
                component: MopaMetaEngagementComponent,
                name: 'Meta Engagement',
                data: { navbarGroup: 'Meta' },
            },
            {
                path: 'resources',
                component: MopaResourcesComponent,
                name: 'Resources',
                data: { navbarGroup: 'Resources' },
            },
            {
                path: 'resources-detailed',
                component: MopaResourcesDetailedComponent,
                name: 'Resources Detailed',
                data: { navbarGroup: 'Resources' },
            },
            {
                path: 'resource-flow',
                component: MopaResourceFlowComponent,
                name: 'Resource Flow',
                data: { navbarGroup: 'Resources' },
            },
            {
                path: 'deco-flow',
                component: MopaDecoFlowComponent,
                name: 'Deco Flow',
                data: { navbarGroup: 'Resources' },
            },
            {
                path: 'realtimestats',
                component: MopaRealtimeStatsComponent,
                name: 'Realtime Stats',
                data: { navbarGroup: 'Tech' },
            },
            {
                path: 'realtimecloudsavestats',
                component: MopaRealtimeCloudSaveStatsComponent,
                name: 'CloudSave',
                data: { navbarGroup: 'Tech' },
            },
            {
                path: 'skadnetwork',
                component: MopaSkadNetworkComponent,
                name: 'SkadNetwork',
                data: { navbarGroup: 'Campaigns' },
            },
            {
                path: 'royalties',
                component: RoyaltiesComponent,
                name: 'Royalties',
                data: { navbarGroup: 'Tech' },
            },
        ],
    },
    {
        path: 'bladebound',
        name: 'Bladebound',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewBB } as GuardData,
        children: [
            {
                path: 'master',
                component: MissingPageComponent,
                name: 'Master',
                data: { disabled: true },
            },
            {
                path: 'sales',
                component: MissingPageComponent,
                name: 'Sales',
                data: { disabled: true },
            },
            {
                path: 'retention',
                component: MissingPageComponent,
                name: 'Retention',
                data: { disabled: true },
            },
            {
                path: 'engagement',
                component: MissingPageComponent,
                name: 'Engagement',
                data: { disabled: true },
            },
            {
                path: 'campaigns',
                component: MissingPageComponent,
                name: 'Campaigns',
                data: { disabled: true },
            },
        ],
    },
    {
        path: 'companytech',
        name: 'Company Tech',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewCompany } as GuardData,
        children: [
            {
                path: 'billing',
                component: CompanyBillingComponent,
                name: 'Billing',
                data: {
                    navbarGroup: 'Tech',
                },
            },
        ],
    },
    {
        path: 'dev',
        name: 'Dev',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewCompany } as GuardData,
        children: [
            {
                path: 'echarts',
                component: DevEChartsChomponent,
                name: 'Echarts use cases',
                data: {
                    navbarGroup: 'Dev',
                },
            },
            // {
            //     path: 'metaeconomy',
            //     component: MopaMetaEconomyComponent,
            //     name: 'Meta Economy',
            //     data: { navbarGroup: 'Dev' },
            // },
        ],
    },
];

const routes: Routes = [
    // redirect
    { path: '', redirectTo: 'dashboards/company/master', pathMatch: 'full' },

    // login
    { path: 'login', component: LoginComponent },

    // authenticated
    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        canActivate: [AuthService],
    },
    {
        path: 'dashboards',
        children: dashboardsRoutes,
    },
    {
        path: 'jobs',
        canActivate: [AuthService],
        title: 'Jobs',
        children: [
            { path: 'summary', component: JobsSummaryComponent },
            { path: 'orchestrators', component: OrchestratorsComponent },
            { path: 'orchestrators/:id', component: OrchestratorComponent },
        ],
    },
    { path: '**', component: MissingPageComponent, canActivate: [AuthService] },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}

export interface DashboardRoute extends Route {
    name: string;
    data?: GuardData | NavbarData;
    route?: string[];
    children?: DashboardRoute[];
}
